import React from "react";
import { AppBar, Toolbar, Typography, Tabs, Tab, Box, Container, IconButton } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/Category";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PrintIcon from "@mui/icons-material/Print";
import HistoryIcon from "@mui/icons-material/History";
import SettingsIcon from "@mui/icons-material/Settings";
import ScaleIcon from "@mui/icons-material/Scale";

const TABS = [
  { path: "/label-studio", label: "Dashboard", icon: <DashboardIcon fontSize="small" /> },
   { path: "/label-studio/categories", label: "Categories", icon: <CategoryIcon fontSize="small" /> },
  { path: "/label-studio/products", label: "Products", icon: <Inventory2Icon fontSize="small" /> },
  { path: "/label-studio/templates", label: "Label Templates", icon: <DesignServicesIcon fontSize="small" /> },
  { path: "/label-studio/generate", label: "Generate Labels", icon: <PrintIcon fontSize="small" /> },
  { path: "/label-studio/weight-sticker", label: "Weight Sticker", icon: <ScaleIcon fontSize="small" /> },
  { path: "/label-studio/print-history", label: "Print History", icon: <HistoryIcon fontSize="small" /> },
  { path: "/label-studio/settings", label: "Settings", icon: <SettingsIcon fontSize="small" /> },
];

const LabelStudioLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeIndex = (() => {
    const idx = TABS.findIndex(
      (t) => location.pathname === t.path || (t.path !== "/label-studio" && location.pathname.startsWith(t.path))
    );
    return idx === -1 ? 0 : idx;
  })();

  // Always return to the Shopkeeper inventory screen, regardless of the current sub-page.
  const handleBack = () => {
    navigate("/create-ShopkeeperInv");
  };

  return (
    <Box sx={{ bgcolor: "#f8f9fa", minHeight: "100vh" }}>
      <AppBar position="static" color="default" elevation={1} sx={{ bgcolor: "#fff" }}>
        <Toolbar>
          <IconButton onClick={handleBack} sx={{ mr: 1 }} aria-label="Back">
            <ArrowBackIcon />
          </IconButton>
          <DesignServicesIcon sx={{ color: "primary.main", mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main" }}>
            Sakhi Label Studio
          </Typography>
        </Toolbar>
        <Tabs
          value={activeIndex}
          onChange={(e, idx) => navigate(TABS[idx].path)}
          variant="scrollable"
          scrollButtons="auto"
          textColor="primary"
          indicatorColor="primary"
          sx={{ px: 1 }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.path} icon={tab.icon} iconPosition="start" label={tab.label} sx={{ minHeight: 48 }} />
          ))}
        </Tabs>
      </AppBar>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Outlet />
      </Container>
    </Box>
  );
};

export default LabelStudioLayout;
